module.exports = {"attrs":{"mplot":"0.4.0"},"className":"Stage","children":[{"attrs":{"name":"backgroundLayer"},"className":"Layer","children":[]},{"attrs":{"name":"shapesLayer"},"className":"Layer","children":[]}]}


//////////////////
// WEBPACK FOOTER
// ./src/store/static/plot/AppPlotBaseStage.json
// module id = 6PNy
// module chunks = 139